// extracted by mini-css-extract-plugin
export default {"failed":"failed_failed__eR-tT","top":"failed_top__Ck9tV","main":"failed_main__rfyrK","main_title":"failed_main_title__vlmH3","main_sub_title":"failed_main_sub_title__csXbl"};